import React from 'react'
import { Query } from 'react-apollo'

export const ToggleableQuery = (props) => {
  if (SSR_DATA.prerendering) {
    return props.children({ loading: true })
  }

  return <Query {...props}>{props.children}</Query>
}
